
import { asyncLibs } from './helpers/async-libs';

// import { barecodeScanner } from './components/barecode-scanner';
import { dialog } from './components/dialog';
import { gtm } from './components/gtm';
import { link } from './components/link';
import { mask } from "./components/mask";
import { scrollToTop } from "./components/scroll-to-top";
import { slider } from './components/slider';
import { sticky } from "./components/sticky";
import { switchs } from "./components/switch";
// import { table } from "./components/table";
// import { termOfUse} from "./components/terms-of-use";
import { textResponsive } from './components/text-responsive';
import { tooltip } from "./components/tooltip";


// MODULES
// import { filters } from './modules/filters';
import { footer } from './modules/footer';
import { header } from "./modules/header";
import { navigation } from './modules/navigation';
import { search } from './modules/search';

// COMPARATOR
import { comparatorPage } from "./modules/comparator/comparator-page";
import { comparatorSelection } from "./modules/comparator/comparator-selection";
import { comparatorNotification } from "./modules/comparator/comparator-notification";

// /**
//  * LEGACY OLD LEGRAND SITE
//  * 
//  * Listes des modules/components
//  * provenant de l'ancien site 
//  * legrand.fr
//  * 
//  * a modifier si possible
//  */
import { wishListManager } from './modules/wishlist-manager/wishlist-manager';

document.addEventListener("DOMContentLoaded", function() {
  // barecodeScanner.init();
  // termOfUse.init();
  dialog.init();
  gtm.init();
  link.init();
  mask.init();
  scrollToTop.init();
  slider.init();
  sticky.init();
  switchs.init();
  // table.init();
  textResponsive.init();
  tooltip.init();



  // MODULES
  // filters.init();
  footer.init();
  header.init();
  navigation.init();
  search.init();

  // COMPARATOR
  comparatorPage.init();
  comparatorSelection.init();
  comparatorNotification.init();

  // ASYNC COMPONENTS LOADING
  asyncLibs('account-user.js', '[data-js-component="account-user"]');
  asyncLibs('accordion.js', '[data-js-component="accordion"]');
  asyncLibs('background.js', '[data-js-component="background"]');
  asyncLibs('banner.js', '[data-js-component="banner"]');
  asyncLibs('barecode-scanner.js', '[data-js-component="barecode-scanner"]', 'md');
  asyncLibs('captcha.js', '[data-js-component="captcha"]');
  asyncLibs('counter.js', '[data-js-component="counter"]');
  asyncLibs('crossknowledge.js', '[data-js-component="crossknowledge"]');
  asyncLibs('dates-formations.js', '[data-js-component="dates-formations"]');
  asyncLibs('deja-vu.js', '[data-ean]');
  asyncLibs('faq-banner.js', '[data-js-component="faq-banner"]');
  asyncLibs('faq-list.js', '[data-js-component="faq-list"]');
  asyncLibs('guide-interactif.js', '[data-js-module="guide-interactif"]');
  asyncLibs('image-360.js', '[data-js-component="image-360"]');
  asyncLibs('promo-in-category.js', '[data-js-component="promo-in-category"]');
  asyncLibs('quantity.js', '[data-js-component="quantity"], .js-wishlist-list-details');
  asyncLibs('scroll-to.js', '[data-js-trigger="scroll-to"]');
  asyncLibs('slider-deja-vu.js', '[data-component="slider-deja-vu"]');
  asyncLibs('table.js', '[data-js-component="table"]');
  asyncLibs('terms-of-use.js', '[data-js-theme="pro"]');
 
  // VIDEO
  asyncLibs('video.js', '[data-js-video]');
  asyncLibs('playlist.js', '[data-js-component="playlist"]');
  asyncLibs('video.consent.js', '[data-js-video-consent]');

  // PRODUCTS
  asyncLibs('product/main.js', '[data-js-component="product-main"]');
  asyncLibs('product/pdf.js', '[data-js-trigger="product-pdf"]');
  asyncLibs('product/variation.js', '[data-js-component="product-variations"]');
  asyncLibs('product/viewer.js', '[data-js-component="product-viewer"]');


  // FORMS
  asyncLibs('form/modules/field-behavior/checkbox-toggle.js', '[data-js-component="checkbox-toggle"]');
  asyncLibs('form/modules/field-behavior/file.js', '[data-js-component="form-file"]');
  asyncLibs('form/modules/field-behavior/input-text.js', '[data-js-component="input-text"]');
  asyncLibs('form/modules/field-behavior/input-autocomplete.js', '[data-js-autocomplete]');
  asyncLibs('form/modules/field-behavior/select.js', '[data-js-component="select"]');
  asyncLibs('form/modules/field-behavior/textarea.js', '[data-js-component="textarea"]');

  asyncLibs('form/form-autofill.js', '[data-js-form-autofill]');
  asyncLibs('form/form-electricien-sign.js', '[data-js-module="form-electricien-sign"]');
  asyncLibs('form/form-preco-fibre-optique.js', '[data-js-module="form-preco-fibre-optique"]');
  asyncLibs('form/form-prequalification.js', '[data-js-module="form-prequalification"]');
  asyncLibs('form/form-validation.js', '[data-js-module="form-validation"]');

  // MODULES
  asyncLibs('espace-connecte.js', '[data-js-component="espace_connecte"]');
  asyncLibs('filters.js', '[data-js-module="filters"]');
  asyncLibs('table-of-contents.js', '[data-js-module="table-of-contents"]');

  // ----------------------------------------
  // Store locator components
  // ----------------------------------------
  // Check for storelocator components - use appropriate module for each type
  const storeLocatorElement = document.querySelector('[data-js-component="storelocator"]');

  // Load full storelocator if present (includes map, filters, etc.)
  if (storeLocatorElement) {
    asyncLibs('storelocator-manager/index', '[data-js-component="storelocator"]');
  }
  
});
